import BlockIcon from "@mui/icons-material/Block";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router";

export function ForbiddenPage({ reason }: { reason?: string }) {
  return (
    <Box sx={{ display: "grid", placeItems: "center", flexGrow: 1, minHeight: 0, p: 3, textAlign: "center" }}>
      <Stack spacing={2} sx={{ alignItems: "center" }}>
        <BlockIcon sx={{ fontSize: 64, color: "text.disabled" }} />
        <Typography variant="h5" component="h1">
          沒有權限
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {reason ?? "您沒有存取這個頁面的權限。"}
        </Typography>
        <Button component={Link} to="/" variant="contained">
          回到總覽
        </Button>
      </Stack>
    </Box>
  );
}
